/**
 * GET /api/notifications — current user's notification feed.
 *
 * Used by NotificationBell + useNotificationPolling. Replaces
 * `data?.notifications ?? data` defensive coercion at NotificationBell.jsx:60.
 */
import { z } from 'zod';

export const NotificationSchema = z.looseObject({
  notificationId: z.string().min(1),
  type: z.string().min(1),
  title: z.string().optional(),
  body: z.string().optional(),
  read: z.boolean().optional(),
  createdAt: z.string().optional(),
  data: z.record(z.string(), z.unknown()).optional(),
});

export type Notification = z.infer<typeof NotificationSchema>;

export const NotificationsListResponseSchema = z.looseObject({
  notifications: z.array(NotificationSchema),
  unreadCount: z.number().optional(),
});

export type NotificationsListResponse = z.infer<
  typeof NotificationsListResponseSchema
>;
